// extracted by mini-css-extract-plugin
module.exports = {"title":"FooterLinkList_title__NZVmM"};